module.exports = __webpack_public_path__ + "img/Arrow_Open.408de898.svg";